import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import useTableFilters from "helpers/hooks/useTableFilters";
import { Link } from "react-router-dom";
import convertDateFormat from "Components/Date/DateFormat";
import { deleteHoliday, getHolidays } from 'helpers/API Calls/System & Settings/Holidays';
import { generateQueryParams } from 'helpers/queryParams';
import DeleteModal from 'Components/Modals/DeleteModal';
import { BOOKING_ACTION_OPTIONS } from "./AddHoliday";

const head = [
{id: 10, name: "#", isSortable: true, key: "id"},
{ id: 1, name: "title", isSortable: true, key: "title" },
{ id: 2, name: "From", isSortable: true, key: "from_date" },
{ id: 3, name: "To", isSortable: true, key: "to_date" },
{ id: 4, name: "Effect", isSortable: true, key: "action" },
{ id: 5, name: "Actions", isSortable: false, key: "actions" }
];

function HolidayListing() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  
  const { filters, updateFilter } = useTableFilters();

  const fetchData = async () => {
    setIsLoading(true);
    const response = await getHolidays(generateQueryParams(filters));
    if (response.success) {
      setData(response.data.items);
      setPagination(response.data.pagination);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (selectedItem) {
      const response = await deleteHoliday(selectedItem.id);
      if (response.success) {
        setDeleteModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  };

  const onCloseClick = () => {
    setDeleteModal(false);
    setSelectedItem(null);
  };
  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Holidays Settings" }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={head}
              pagination={pagination}
              isAddButton={true}
              buttonText="Add New Holiday"
              to="create"
              updateFilter={updateFilter}
              filters={filters}
              > 
              {data.length > 0 && data.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td className="text-truncate">{item.title}</td>
                  <td>{convertDateFormat(item.from_date)}</td>
                  <td>{convertDateFormat(item.to_date)}</td>
                  <td>{BOOKING_ACTION_OPTIONS.find(option => option.value === item.action)?.label || ''}</td>
                  <td>
                    <div>
                      <Link to={`${item.id}/edit`} className="btn btn-primary btn-sm mx-1"><i className="bx bx-pencil"/></Link>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(item)}><i className="mdi mdi-trash-can-outline"></i></button>
                    </div>
                  </td>
                </tr>))
              }
              {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
            </PaginatedTable>
          </CardBody>
        </Card>
        }
      </Container>
    </div>
    {deleteModal && <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteConfirm}
      onCloseClick={onCloseClick}
      message={`"${selectedItem?.title}" holiday`}
    />}
    </>

  )
}

export default HolidayListing
